export default {
	experienceRead: {
		"msg": "操作成功",
		"code": 200,
		"data": [{
			"course": [{
				"author": '佚名',
				"courseArticleName": "小小的善",
				"content": [
					"许多年以前的一个夏天,在一列南下的火车上，一位满脸稚气的男青年倚窗而坐。他是个农村娃，一件崭新的白色短袖衬衫掩盖不住黝黑的皮肤。在此之前,他连火车都没有坐过,他要到南方去上梦寐以求的大学。男青年对面的座位上,坐着一对母子。",
					"车厢内闷热异常。男青年感到口渴难耐。", "“方便面、健力宝、矿泉水……”乘务员大声地叫卖着。",
					"健力宝?男青年知道,这是一种奢侈的饮料。读高中时,班里有钱的同学才喝得起,爸妈从未给自己买过。如今,他要到外地上学了,衣兜里有了一些可以支配的零花钱。犹豫再三,他终于从衣兜里摸出了一张皱巴巴的5元钱，递给乘务员。",
					"男青年不知如何开启这罐饮料。他把健力宝拿在手里，颠来倒去看了又看。最后，他把目光停在了拉环的位置。迟疑了一会儿,他从腰间摸出了一把水果刀,企图在拉环的位置把健力宝撬开,撬了两下,发现易拉罐的壳很坚硬。他便停下了手中的水果刀，又把目光盯在拉环处。",
					"男青年不知道如何开启这罐饮料。这时,却听见对面的妇女对儿子说:“童童,快把健力宝给妈妈拿过来。”小男孩说:“妈妈,你刚喝过水,怎么又渴了?”",
					"“快，听话!”小男孩便站在车座上把手伸进了车厢旁边挂着的塑料袋。",
					"那位妇女把健力宝拿在手中，眼睛盯在拉环上，余光注视着男青年,发觉男青年正盯着自己手中的易拉罐。只听“嘭”的一声,健力宝打开了。随之，车厢里又传出“嘭”的一声响，男青年的易拉罐也打开了。妇女微微地笑了一下,喝了一口,就把自己的健力宝放在了茶几上。男青年向妇女投去了感激的一瞥,便开始品味健力宝的甘甜。妇女也没碰茶几上的那罐健力宝。显然，她并不渴。",
					"几年后，男青年参加了工作,却仍然对这件事情记忆犹新。他感激那位善良的中年妇女。她为了不使他难堪,没有直接教他易拉罐的开启方法,而是间接地完成了这一过程。妇女的这一举动是一种小小的善。",
					"男青年把这种感激化成了更多小小的善,带到社会的角角落落。", "那位男青年就是我，那年我18 岁。"
				],
				"number": 790,
				"children": [{
					"title": "（  ）了一会儿,他从腰间摸出了一把水果刀。",
					"option": ["犹豫", "迟疑", "观望", "彷徨"],
					"answer": "迟疑"
				}, {
					"title": "读（  ）时,班里有钱的同学才喝得起。",
					"option": ["小学", "初中", "高中", "中学"],
					"answer": "高中"
				}, {
					"title": "一件崭新的白色短袖衬衫（  ）不住黝黑的皮肤。",
					"option": ["掩盖", "掩饰", "隐藏", "遮盖"],
					"answer": "掩盖"
				}, {
					"title": "车厢内（  ）异常。男青年感到口渴难耐。",
					"option": ["闷热", "灼热", "炎热", "酷热"],
					"answer": "闷热"
				}, {
					"title": "几年后，男青年参加了工作,却仍然对这件事情（  ）。",
					"option": ["记忆犹新", "历历在目", "念念不忘", "难以忘怀"],
					"answer": "记忆犹新"
				}, {
					"title": "一位满脸（  ）的男青年倚窗而坐。",
					"option": ["幼稚", "青涩", "稚气", "懵懂"],
					"answer": "稚气"
				}, {
					"title": "许多年以前的一个（  ）,在一列南下的火车上。",
					"option": ["春天", "夏天", "秋天", "冬天"],
					"answer": "夏天"
				}]
			}]
		}, {
			"course": [{
				"author": '佚名',
				"courseArticleName": "“哑巴”学生",
				"content": [
					"从前,东非地区有一位很有名望的医生。他的医术很高明,不过他从来不肯把自己的医术传授给别人。后来,他年纪大了，才答应只收一个学生,而且这个学生必须是个哑巴。",
					"在医生居住的那座城里,有一个贫苦的女人。这一天,她对自己唯一的儿子说:“孩子,妈妈没有钱供你读书。你装成哑巴去学医吧。学了好医道,好为人们解除病痛。记住，无论医生怎么考验你,你都要克制住自己,万万不可以说话。”",
					"孩子答应了母亲的要求,第二天就去求拜医生。医生用各种方法进行试探,但孩子始终没说一句话。最后，医生确信这孩子是个哑巴，便开始向他传授医术。“哑巴”学生勤奋好学,聪明伶俐,老师感到很满意。几年过去了,孩子学到了许多绝招,很多疑难病症他都可以独自处理了。",
					"一天,来了一位病人,他说头痛得很厉害。医生诊断后说:“必须马上动手术,否则有生命危险!”脑壳揭开后,大家都吓了一跳，原来，里面寄生着一条白蠕虫，虫子一动，病人就痛得要命。于是，医生拿出一把细钩子,打算把虫子钩出来。“哑巴”学生像往常一样全神贯注地观察着老师的动作。这时,他突然想到:“这样做很危险,万一钩不出虫子而伤了病人的脑子,后果就严重了。应该采取别的方法才好。可是,如果我说了,就会立刻暴露了我不是哑巴这个真相。老师知道我欺骗了他,会赶我走的。”他急得直冒汗,再一想:“如果我不说,病人发生了意外,造成他一生痛苦,这样不仅没有尽到医生的职责，而且会坏了老师的声誉。”于是,他平静地说:“老师,您这样做太危险了。”说完,他接过老师手里的钩子,放在火上烤了烤,拿过来挨近蠕虫。蠕虫被炙热的钩子烫着了,蠕动起来,很快就爬出了病人的脑子。接着，“哑巴”学生缝合了刀口。医生听到“哑巴”学生突然开口说话了,惊奇万分,但他还是允许学生做完了手术",
					"“你不是哑巴，为什么欺骗我?”手术后，医生质问自己的学生，并打算赶他走。",
					"这时,学生坦然地回答道:“是的，老师,我欺骗了您,很对不起您。不过那是为了学到医术。可现在，看见病人受到死亡的威胁,作为医生，我不能再沉默了。”",
					"老师听了很受感动，原谅了他。"
				],
				"number": 849,
				"children": [{
					"title": "医生（  ）这孩子是个哑巴，便开始向他传授医术。",
					"option": ["相信", "确信", "深信", "信任"],
					"answer": "确信"
				}, {
					"title": "从前,东非地区有一位很有（  ）的医生。",
					"option": ["名望", "名声", "威望", "名气"],
					"answer": "名望"
				}, {
					"title": "“哑巴”学生像往常一样（  ）地观察着老师的动作。",
					"option": ["全神贯注", "聚精会神", "目不转睛", "专心致志"],
					"answer": "全神贯注"
				}, {
					"title": "孩子,妈妈没有钱供你（  ）。你装成哑巴去学医吧。",
					"option": ["学习", "读书", "上学", "念书"],
					"answer": "读书"
				}, {
					"title": "（  ）医生怎么考验你,你都要克制住自己,万万不可以说话。",
					"option": ["不管", "无论", "不论", "即便"],
					"answer": "无论"
				}, {
					"title": "在医生居住的那座城里,有一个（  ）的女人。",
					"option": ["贫困", "困苦", "穷苦", "贫苦"],
					"answer": "贫苦"
				}, {
					"title": "学了好医道,好为人们（  ）病痛。",
					"option": ["解除", "消除", "祛除", "排除"],
					"answer": "解除"
				}]
			}]
		}, {
			"course": [{
				"author": '佚名',
				"courseArticleName": "空城计",
				"content": [
					"三国时期，诸葛亮因错用马谡而失掉战略要地——街亭,决定全军撤回汉中，自己先带5000兵马去西城县运送粮草。魏国大将司马懿率领15万大军正向诸葛亮所在的西城蜂拥而来。这时,诸葛亮身边没有大将,只有一班文官,所带领的5000兵马，也有一半运粮草去了，只剩2500名士兵在城里。众人听到司马懿带兵前来的消息都大惊失色。诸葛亮登上城头一看,果然尘土冲天,魏军分路往西城县杀来。只见诸葛亮镇定自若,传令:城里百姓不得出门,把所有的旌旗都藏起来;四个城门打开,每个城门内外派20多名士兵扮成百姓模样,洒水扫街;其余士兵原地不动,不得高声喊叫,否则立即斩首。一切准备就绪,诸葛亮自己披上鹤氅,戴上高高的纶巾,领着两个小书童,带上一张琴,登上城楼,凭栏坐下,燃起香,慢慢弹起琴来。好一副闲情逸致!",
					"司马懿的先头部队到达城下,见了这种气势,都不敢轻易入城，便急忙返回报告司马懿。司马懿听后,笑着说:“这怎么可能呢?”于是便令部队停下,自己飞马前去观看。离城不远，他果然看见诸葛亮端坐在城楼上,笑容可掬,正在悠闲地弹琴。左面一个书童手捧宝剑,右面一个书童手里拿着拂尘。整个城池一片寂静,城门里外，只有20多个百姓模样的人在低头洒扫,旁若无人。司马懿看后,心中大疑，连忙指挥部队撤退。",
					"他的二子司马昭说:“莫非是诸葛亮没有多少兵力,故意这样的?父亲您为什么要退兵呢?”司马懿板着脸说:“诸葛亮平时一向谨慎,从不冒险。现在城门大开,里面必有重兵埋伏。我军如果进去,正好中了他们的计。你们懂什么?还不快快撤退!”",
					"诸葛亮见魏军远去，拍手哈哈大笑起来。", "众官员无不惊奇：“司马懿是魏国的名将,如今统率15万精兵来到这里，见了丞相,慌忙撤退,这是什么原因呢?”",
					"诸葛亮这才道出缘由：“司马懿是个疑心很重的人,他知道我平生谨慎,从不冒险。他看到如此情形,怀疑有重兵埋伏,所以很快退去。我并不是想冒险，实在是不得不这样啊!”",
					"大家敬佩地说:“丞相的计谋，鬼神也不能预料啊!”"
				],
				"number": 801,
				"children": [{
					"title": "大家（  ）地说:“丞相的计谋，鬼神也不能预料啊!”",
					"option": ["敬仰", "尊敬", "敬佩", "恭敬"],
					"answer": "敬佩"
				}, {
					"title": "三国时期，诸葛亮因错用马谡而（  ）战略要地——街亭。",
					"option": ["失掉", "损失", "错失", "丧失"],
					"answer": "失掉"
				}, {
					"title": "魏国大将司马懿（  ）15万大军正向诸葛亮所在的西城蜂拥而来。",
					"option": ["统领", "率领", "带领", "统率"],
					"answer": "率领"
				}, {
					"title": "自己先带（  ）兵马去西城县运送粮草。",
					"option": ["3000", "4000", "5000", "6000"],
					"answer": "5000"
				}, {
					"title": "众人听到司马懿带兵前来的消息都（  ）。",
					"option": ["大惊失色", "胆战心惊", "大吃一惊", "心惊胆战"],
					"answer": "大惊失色"
				}, {
					"title": "离城不远，他（  ）看见诸葛亮端坐在城楼上。",
					"option": ["果然", "果真", "的确", "居然"],
					"answer": "果然"
				}, {
					"title": "燃起香,慢慢弹起琴来。好一副（  ）!",
					"option": ["悠然自得", "优哉游哉", "豪情逸致", "闲情逸致"],
					"answer": "闲情逸致"
				}]
			}]
		}, {
			"course": [{
				"author": '佚名',
				"courseArticleName": "再坚持一下",
				"content": ["查德威尔是一个成功横渡英吉利海峡的女性，但她并不满足，决定超越自己，她想从卡塔林纳岛游到加利福尼亚。",
					"1952年7月4日清晨,加利福尼亚海岸下起了浓雾。查德威尔的挑战在继续着。",
					"时间一个小时一个小时地过去了,雾很大，她几乎看不到护送她的小艇。刺骨的海水冻得她嘴唇发紫、身体发麻,旅程十分艰苦。连续16个小时的游泳使她的四肢像灌了铅一样沉重,查德威尔感到自己不行了。这时,她望了望远方,四周茫茫一片,什么都看不到。她不知道自己离目的地还有多远，因为到现在为止,连海岸都看不到。",
					"查德威尔越想越累,她感到自己一丝劲儿也用不上了，她知道自己不能再游了。终于，筋疲力尽的查德威尔对陪伴她的艇上的人说:“我放弃了,快拉我上去吧。”",
					"“不要这样!只有一英里就到了，坚持!”那人冲着她大叫。",
					"“我不信，”查德威尔喘着大气，疲惫不堪地摇着头，“如果只有一英里，我怎么看不到海岸线？快拉我上去。”", "最终,查德威尔被小艇上的人拉了上去。",
					"小艇飞快地向前开去，不到一分钟,加利福尼亚的海岸出现在眼前——因为大雾，它在半英里范围内才被人看见。",
					"查德威尔后悔莫及：为什么不相信别人的话，再坚持一下呢？如果再坚持一下,胜利就在眼前。事后她说:令她半途而废的最重要的原因不是疲劳,也不是寒冷,而是她在浓雾中看不到目标。",
					"其实，成功与失败的差距往往仅一步之遥，只要咬紧牙关坚持一下,胜利便向你招手。但是许多人正是因为在前面的困难中已经筋疲力尽了,在最后的关头,即使遇到微小的困难或障碍都可能放弃而导致前功尽弃。只有咬紧牙关再坚持一下,胜利便近在眼前。所以，成功往往来自“再坚持一下”的坚持之中。"
				],
				"number": 668,
				"children": [{
					"title": "（  ）的查德威尔对陪伴她的艇上的人说:“我放弃了,快拉我上去吧。”",
					"option": ["筋疲力尽", "心力交瘁", "疲惫不堪", "身心交瘁"],
					"answer": "筋疲力尽"
				}, {
					"title": "“我不信，”查德威尔喘着大气，（  ）地摇着头。",
					"option": ["筋疲力尽", "心力交瘁", "疲惫不堪", "身心交瘁"],
					"answer": "疲惫不堪"
				}, {
					"title": "即使遇到微小的困难或障碍都可能放弃而导致（  ）。",
					"option": ["前功尽弃", "功亏一篑", "半途而废", "功败垂成"],
					"answer": "前功尽弃"
				}, {
					"title": "（  ）年7月4日清晨,加利福尼亚海岸下起了浓雾。",
					"option": ["1951", "1952", "1953", "1954"],
					"answer": "1952"
				}, {
					"title": "刺骨的海水冻得她嘴唇发紫、身体发麻,旅程十分（  ）。",
					"option": ["辛苦", "艰辛", "艰苦", "艰难"],
					"answer": "艰苦"
				}, {
					"title": "查德威尔（  ）：为什么不相信别人的话，再坚持一下呢？",
					"option": ["追悔莫及", "后悔莫及", "后悔不已", "懊悔不及"],
					"answer": "后悔莫及"
				}, {
					"title": "雾很大，她（  ）看不到护送她的小艇。",
					"option": ["似乎", "险些", "差点", "几乎"],
					"answer": "几乎"
				}]
			}]
		}, {
			"course": [{
				"author": '佚名',
				"courseArticleName": "满满一大杯牛奶",
				"content": ["一个出身贫苦的男孩,为了积攒学费而挨家挨户地推销商品。可他推销得很不顺利，以致他有些绝望。",
					"这天傍晚,奔走了一整天的他又累又渴又饿,可身上只有几十美分。他决定向下一户人家讨一些吃的。",
					"可是，当一位天使般的姑娘打开大门时,他却有点不知所措了。他不好意思张口要饭吃，只求姑娘给他一口水喝。",
					"姑娘看出他的疲惫和饥饿，微笑着给了他满满一大杯牛奶。", "男孩“咕嘟咕嘟”,一口气喝完了牛奶。他不敢抬头看姑娘，低声地说:“我应该付您多少钱?”",
					"“您并不欠我任何东西。”姑娘仍旧微笑着对他说，“妈妈经常教导我们：施以爱心，不图回报。”",
					"泪水涌上男孩的眼眶，他轻轻地说:“那么,就请您接受我由衷的感谢吧!”便虔诚地朝姑娘一鞠躬。",
					"其实，男孩原本有了退学的打算,如今,他仿佛看到上帝在朝他点头微笑,他觉得浑身是劲,男子汉的豪气又迸发出来了。",
					"若干年后,有位来自小城镇的年轻妇女得了一种罕见的重病。当地的医生束手无策，只好把她送到附近的大城市去,请专家们会诊治疗。",
					"一位有名的医生参加了会议。当他看到病历上的家庭地址时，双眼闪着奇异的光芒,他马上直奔病房。来到病床前，他一眼就认出了:这位病人就是当年送过满满一大杯牛奶给他喝的天使。他返回会诊室，决心竭尽所能来挽救她的生命,回报这位“施以爱心，不图回报”的姑娘。",
					"经过艰辛的努力,他们终于成功了,年轻妇女渐渐康复了。这位医生要求医院把最后的账单送到他的办公室，他付清了一切费用，并在账单的边缘写了一行字,微笑着签上了自己的名字。",
					"当账单送到年轻妇女的手上时,她不敢打开看，因为她确信:这笔费用将花去她所有的积蓄,或许还不够。最后,她还是鼓起了勇气,颤抖着打开了这沓厚厚的账单。账单边缘的那行字,锁定了她的目光，她不禁轻声读了出来：",
					"“医药费——满满一大杯牛奶,霍华德·凯利医生。”"
				],
				"number": 741,
				"children": [{
					"title": "这天（  ）,奔走了一整天的他又累又渴又饿。",
					"option": ["晚上", "黄昏", "傍晚", "下午"],
					"answer": "傍晚"
				}, {
					"title": "如今,他（  ）看到上帝在朝他点头微笑。",
					"option": ["好像", "仿佛", "似乎", "犹如"],
					"answer": "仿佛"
				}, {
					"title": "姑娘看出他的（  ）和饥饿，微笑着给了他满满一大杯牛奶。",
					"option": ["疲倦", "疲劳", "疲惫", "疲乏"],
					"answer": "疲惫"
				}, {
					"title": "一个出身（  ）的男孩,为了积攒学费而挨家挨户地推销商品。",
					"option": ["贫困", "贫苦", "贫穷", "穷苦"],
					"answer": "贫苦"
				}, {
					"title": "当一位天使般的姑娘打开大门时,他却有点（  ）了。",
					"option": ["手足无措", "束手无策", "惊慌失措", "不知所措"],
					"answer": "不知所措"
				}, {
					"title": "可他推销得很不顺利，以致他有些（  ）。",
					"option": ["绝望", "失望", "灰心", "消极"],
					"answer": "绝望"
				}, {
					"title": "他返回会诊室，决心（  ）来挽救她的生命。",
					"option": ["竭尽所能", "竭尽全力", "尽其所能", "不遗余力"],
					"answer": "竭尽所能"
				}]
			}]
		}]
	}
}